export default {
  loginPasswordByUserName: '/auth/loginPasswordByUserName',
  updateUserAuthentication: '/auth/updateUserAuthentication',
  getAllSubAdminOfInstitute: '/auth/getAllSubAdminOfInstitute',
  getUserAuthenticationByUid: '/auth/getUserAuthenticationByUid',
  getUserAuthenticationsByUIds: '/auth/getUserAuthenticationsByUIds',
  resetPassword: '/auth/resetPassword'
}
